//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getNewEmail, sendEmail} from '@/api/index'

export default {
    mounted() {
        this.$vux.loading.show({
            text: '加载中...'
        });
        //获取本地存储的数据（定制coa查询结果）
        let
            t = this,
            coa = JSON.parse(sessionStorage.getItem('coab'));
        if (coa.deliveryDate) {
            let str = coa.deliveryDate,
                arr = str.split(' '),
                arrNew = arr.splice(0, 1);
            t.orderTime = arrNew.join(' ');
            sessionStorage.setItem('coabOrderTime', t.orderTime);
        }
        t.orderId = coa.deliveryNumber;
        sessionStorage.setItem('coabOrderId', t.orderId);
        coa.coaBaseDtos.forEach(item => {
            item.select = false;
            t.fileList.push(item);
        });
        //判断邮箱是获取的最新邮箱还是手动选择的邮箱
        if (!this.email) {
            //最新邮箱
            getNewEmail().then(res => {
                this.$vux.loading.hide();
                if (res.data.code === 0) {
                    t.emailAddress = res.data.data.email.emailAddress;
                } else {
                    t.$vux.toast.text(res.data.msg, 'middle');
                }
            });
        } else {
            //用户手动选择的邮箱
            this.emailAddress = this.email.emailAddress
            this.$vux.loading.hide();

        }
    },
    data() {
        return {
            orderId: '',
            orderTime: '',
            fileList: [],
            emailAddress: '填写邮箱',
            isAll: false,
            subjectBody: '',
            fromtype:1
        }
    },
    beforeRouteEnter(to, from, next) {
        console.log(from.path)
        if(from.path == '/personalBarCode'){
            next(vm=>{
                vm.fromtype = 2;
            })
        }else{
            next(vm=>{
                vm.fromtype = 1;
            })
        }
    },

    computed: {
        //用户选择的邮箱
        email() {
            return this.$store.state.email;
        }
    },
    methods: {
        //要发送的文件点选功能
        selectItem(index) {
            let t = this, item = t.fileList[index];
            item.select = !item.select;
            if (!item.select) this.isAll = false;
        },
        //要发送的文件全选功能
        selectAll() {
            if (!this.isAll) {
                this.fileList.map(item => {
                    item.select = true;
                    return item;
                });
                this.isAll = true
            } else {
                this.fileList.map(item => {
                    item.select = false;
                    return item;
                });
                this.isAll = false
            }
        },
        //点击“打开”查询产品合格证书
        openDetail(barcode, iccBatchNo, enterstatu) {
            let t = this,
                deliveryNumber = t.orderId;
            // 把COA报告接口要的参数封装到data里通过路由传到下一个页面
            t.$router.push({
                path: '/personalAnalysisDetail',
                query: {
                    barcode,
                    iccBatchNo,
                    enterstatu,
                    deliveryNumber,
                    fromtype:t.fromtype
                }
            })
        },
        //选择其他邮箱
        selectEmail() {
            let t = this;
            t.$router.push('/selectEmail')
        },
        //发送邮件
        sendEmail() {
            let
                t = this,
                sendEmailList = t.fileList.filter(item => {
                    return item.select;
                });
            if (!sendEmailList.length) {
                t.$vux.toast.text('请选择需要发送的邮件', 'middle');
            } else {
                let enterstatu = sendEmailList[0].enterstatu;
                if (enterstatu === 0) {
                    t.subjectBody = sendEmailList.map(item => {
                        return '林德产品分析报告-' + t.orderId + '-' + item.barcode;
                    });
                } else {
                    t.subjectBody = '林德产品分析报告-' + t.orderId + '-' + t.orderTime;
                }
                let htmlBody = sendEmailList.map(item => {
                    return escape('https://ecoa2.lindemobile.cn/pc/#/pc/personalAnalysisEmail?barcode=' + item.barcode + '&iccBatchNo=' + item.iccBatchNo + '&deliveryNumber=' + t.orderId + '&enterstatu=' + item.enterstatu + "\r\n")
                }).join('');
                this.$vux.loading.show({ text: '发送中...' });
                sendEmail({
                    htmlBody,
                    address: t.emailAddress,
                    subjectBody: t.subjectBody
                }).then(res => {
                    if (res.data.code === 0) {
                        this.$vux.loading.hide();
                        t.$vux.toast.text('发送成功', 'middle');
                    } else {
                        this.$vux.loading.hide();
                        t.$vux.toast.text(res.data.msg, 'middle');
                    }
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/COA/personalAnalyzeResult.vue